import React, { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi';

const History = () => {

  const queryParams = new URLSearchParams(window.location.search)
  const heroNo = queryParams.get("heroNo")
  const supporterNo = queryParams.get("supporterNo")

  const [history, setHistory] = useState()
  const [byUser, setByUser] = useState(true)

  const load = async () => {
    const _history = await butterflyApi.getHistory(heroNo, supporterNo, byUser)
    setHistory(_history)
  }

  useEffect(() => {
    load();
  }, [heroNo, supporterNo, byUser])

  return <div className="px-4 mt-12 max-w-3xl">
    <div className="mb-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
    </div>
    <div className="mb-4 flex gap-2">
      {[{ label: 'User', value: true }, { label: 'Bot', value: false }, { label: 'All', value: 'all' }].map(({ label, value }) => (
        <button
          key={label}
          onClick={() => setByUser(value)}
          className={`px-3 py-1 text-sm rounded border ${byUser === value ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400'}`}
        >{label}</button>
      ))}
    </div>
    {history && history.length === 0 && <div className="text-gray-400 text-sm">기록 없음</div>}
    {history && history.length > 0 && (
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="bg-gray-100 text-gray-600 text-left">
            <th className="px-3 py-2 border border-gray-200">No</th>
            <th className="px-3 py-2 border border-gray-200">heroNo</th>
            <th className="px-3 py-2 border border-gray-200">scriptNo</th>
            <th className="px-3 py-2 border border-gray-200">action</th>
            <th className="px-3 py-2 border border-gray-200">일시</th>
          </tr>
        </thead>
        <tbody>
          {history.map(item => (
            <tr key={item.historyNo} className="hover:bg-gray-50">
              <td className="px-3 py-2 border border-gray-200 text-gray-400">{item.historyNo}</td>
              <td className="px-3 py-2 border border-gray-200">
                <a href={`/manage/hero?heroNo=${item.heroNo}`} className="text-blue-600 underline">{item.heroNo}</a>
              </td>
              <td className="px-3 py-2 border border-gray-200">
                <a href={`/manage/story?heroNo=${item.heroNo}&scriptNo=${item.scriptNo}`} className="text-blue-600 underline">{item.scriptNo}</a>
              </td>
              <td className="px-3 py-2 border border-gray-200">{item.action}</td>
              <td className="px-3 py-2 border border-gray-200 text-gray-500">{item.registerDatetime}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
}

export default History